module.exports = __webpack_public_path__ + "img/prize1_active.401246e.png";